import React, { useEffect } from 'react';
import { LabelledSelect } from '../../../../../../components/LabelledSelect';
import useOptions from '../../../../../../hooks/useOptions';
import { useInterviewTemplates } from '../../../../../../queries/v1/applicant_tracking/useInterviewTemplates';
import { InterviewTemplate } from '../../../../../../entities/v1/applicant_tracking/InterviewTemplate';

interface PropTypes {
  interviewTemplate: InterviewTemplate;
  defaultInterviewTemplateId?: number | null;
  setInterviewTemplate: (option: InterviewTemplate) => void;
}

const interviewTemplateToOption = (template: InterviewTemplate) => {
  if (!template) return null;

  return {
    label: template.name,
    value: template.id.toString(),
  };
};

export function InterviewTemplateSelector(props: PropTypes) {
  const { data: interviewTemplates, isLoading } = useInterviewTemplates();
  const options = useOptions(
    interviewTemplates?.interviewTemplates ?? [],
    interviewTemplateToOption,
  );

  useEffect(() => {
    if (!props.interviewTemplate) {
      props.setInterviewTemplate(
        interviewTemplates?.interviewTemplates.find(
          (template) => template.id === props.defaultInterviewTemplateId,
        ),
      );
    }
  }, [props.interviewTemplate, interviewTemplates?.interviewTemplates]);

  return (
    <LabelledSelect
      disabled={isLoading}
      options={options}
      label='Scheduling Template'
      size='sm'
      labelClassName='text-dark-500 fs-5'
      selected={interviewTemplateToOption(props.interviewTemplate)}
      className='me-3 mb-4'
      onChange={(option) =>
        props.setInterviewTemplate(
          interviewTemplates?.interviewTemplates.find(
            (template) => template.id.toString() == option.value,
          ),
        )
      }
    />
  );
}
